
import { Component, OnInit, ViewContainerRef, OnDestroy, ViewChild } from '@angular/core';
import { TdDataTableService, TdDataTableSortingOrder, ITdDataTableSortChangeEvent, ITdDataTableColumn, TdDialogService, TdLoadingService, TdSearchBoxComponent } from '@covalent/core';
import { IPageChangeEvent } from '@covalent/core';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';

import { AccountingService } from '../../accounting/accounting.service';
import { InventoryService } from '../inventory.service';
import { ProductService } from '../../purchasing/products/product.service';
import { PieceGrouped } from '../pieceGrouped';
import { Branch } from '../../accounting/branch';
import { Fabrictype } from '../../purchasing/fabrictypes/fabrictype';
import { SettingsService } from '../../../shared/services/settings.service';
import { ExportService } from '../../../shared/services/export.service';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { MdDialogRef, MdDialog } from '@angular/material';
import { ReportService } from '../../../shared/services/report.service';
import { DateRangeDialogComponent } from '../../../shared/dialogs/date-range-dialog/date-range-dialog.component';
import { BranchService } from '../../accounting/branches/branch.service';
import { DateSelectDialogComponent } from '../../../shared/dialogs/date-select-dialog/date-select-dialog.component';
import { DateAndProductSelectDialogComponent } from '../../../shared/dialogs/date-and-product-select-dialog/date-and-product-select-dialog.component';
import { Utils } from '../../../shared/utils';


@Component({
  selector: 'app-inventory-list',
  templateUrl: './inventory-list.component.html',
  styleUrls: ['./inventory-list.component.scss'],
  providers: [ReportService]
})

export class InventoryListComponent implements OnInit, OnDestroy {
  @ViewChild('searchBox') _searchBox: TdSearchBoxComponent;

  data: PieceGrouped[];
  subscription: Subscription = new Subscription();
  totalPiecesValue: number = 0;
  totalAvailableValue: number = 0;
  totalReservedValue: number = 0;
  totalMissingValue: number = 0;
  totalOrderedValue: number = 0;

  pagePiecesValue: number = 0;
  pageAvailableValue: number = 0;
  pageReservedValue: number = 0;
  pageMissingValue: number = 0;
  pageOrderedValue: number = 0;

  allBranches$: Observable<Branch[]>;
  allFabricTypes$: Observable<Fabrictype[]>;
  availableUnits: string[] = ['Meters', 'Yards'];

  _selectedBranch: number = 0;
  _selectedFabricTypeId: number = 0;
  _selectedFabricType: Fabrictype = new Fabrictype();
  _selectedUnit: string = 'Meters';

  allColumns: ITdDataTableColumn[] = [
    { name: 'collection_name', label: 'Collection' },
    { name: 'design_color', label: 'Design / Color' },
    { name: 'branch', label: 'Branch' },
    { name: 'pieces', label: 'Pieces' },
    { name: 'grade_code', label: 'Grade' },
    { name: 'available', label: 'Available (M)' },
    { name: 'available_y', label: 'Available (y)' },
    { name: 'available_Msq', label: 'Available (M²)' },
    { name: 'available_Sft', label: 'Available (SqFt)' },
    { name: 'reserved', label: 'Reserved (M)' },
    { name: 'reserved_y', label: 'Reserved (y)' },
    { name: 'reserved_Msq', label: 'Reserved (M²)' },
    { name: 'reserved_Sft', label: 'Reserved (SqFt)' },
    { name: 'reserved_N', label: 'Reserved' },
    { name: 'missing', label: 'Back Order (M)' },
    { name: 'missing_y', label: 'Back Order (y)' },
    { name: 'missing_Msq', label: 'Back Order (M²)' },
    { name: 'missing_Sft', label: 'Back Order (SqFt)' },
    { name: 'ordered', label: 'Ordered (M)' },
    { name: 'ordered_y', label: 'Ordered (y)' },
    { name: 'ordered_Msq', label: 'Ordered (M²)' },
    { name: 'ordered_Sft', label: 'Ordered (SqFt)' },
    { name: 'ordered_N', label: 'Ordered' },
    { name: 'actions', label: '' }
  ];

  // columns: ITdDataTableColumn[] = [
  //   { name: 'collection_name', label: 'Collection' },
  //   { name: 'design_color', label: 'Design / Color' },
  //   { name: 'branch', label: 'Branch' },
  //   { name: 'pieces', label: 'Pieces' },
  //   { name: 'grade_code', label: 'Grade' },
  //   { name: 'available', label: 'Available (M)' },
  //   { name: 'available_y', label: 'Available (y)' },
  //   { name: 'reserved', label: 'Reserved (M)' },
  //   { name: 'reserved_y', label: 'Reserved (y)' },
  //   { name: 'missing', label: 'Back Order (M)' },
  //   { name: 'missing_y', label: 'Back Order (y)' },
  //   { name: 'ordered', label: 'Ordered (M)' },
  //   { name: 'ordered_y', label: 'Ordered (y)' }
  // ];

  // columns2: ITdDataTableColumn[] = [
  //   { name: 'collection_name', label: 'Collection' },
  //   { name: 'design_color', label: 'Design / Color' },
  //   { name: 'branch', label: 'Branch' },
  //   { name: 'pieces', label: 'Pieces' },
  //   { name: 'grade_code', label: 'Grade' },
  //   { name: 'available_Msq', label: 'Available (Msq)' },
  //   { name: 'available_Sft', label: 'Available (Sft)' },
  //   { name: 'reserved_Msq', label: 'Reserved (Msq)' },
  //   { name: 'reserved_Sft', label: 'Reserved (Sft)' },
  //   { name: 'missing_Msq', label: 'Back Order (Msq)' },
  //   { name: 'missing_Sft', label: 'Back Order (Sft)' },
  //   { name: 'ordered_Msq', label: 'Ordered (Msq)' },
  //   { name: 'ordered_Sft', label: 'Ordered (Sft)' }
  // ];

  // columns3: ITdDataTableColumn[] = [
  //   { name: 'collection_name', label: 'Collection' },
  //   { name: 'design_color', label: 'Design / Color' },
  //   { name: 'branch', label: 'Branch' },
  //   { name: 'pieces', label: 'Pieces' },
  //   { name: 'grade_code', label: 'Grade' },
  //   { name: 'reserved_N', label: 'Reserved' },
  //   { name: 'ordered_N', label: 'Ordered' }
  // ];

  filteredData: any[];
  filteredTotal: number;
  //searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  //pageSize: number = 50;
  sortBy: string = 'design_color';
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;
  selectedRows: any[];

  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: TdDialogService,
    private _viewContainerRef: ViewContainerRef,
    private _inventoryService: InventoryService,
    private _loadingService: TdLoadingService,
    private _productService: ProductService,
    private _settingsService: SettingsService,
    private _reportService: ReportService,
    private _branchService: BranchService,
    public _exportService: ExportService,
    public _authService: AuthenticationService,
    private _dialog: MdDialog
  ) { }

  ngOnInit(): void {
    //this.subscription = this.getPieces(0, 0);

    this.presetSearchBox();

    //Use all branches here
    this.allBranches$ = this._branchService.getBranches();

    console.log('requesting all branches');
    this.allBranches$.subscribe(
      response => {

        console.log('all branches returned');
        // Default to home branch
        this._selectedBranch = this._authService.getHomeBranch();

        console.log('requesting all fabric types');
        this.allFabricTypes$ = this._productService.getFabricTypes();
        this.allFabricTypes$.subscribe(
          response => {
            console.log("# fabric types: " + response.length);

            // Default to the first fabric type
            this._selectedFabricTypeId = Number.parseInt(response[0].id);

            // And get pieces right after
            this.onSelect(this._selectedFabricTypeId);
            this.getPieces(this._selectedFabricTypeId, this._selectedBranch);

          },
          error => {
            this._dialogService.openAlert({ title: 'Error!', message: 'Error retrieving fabric types'});
          }
        );
      },
      error => {
        this._dialogService.openAlert({ title: 'Error!', message: 'Error retrieving branches'});
      }
    );


  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  presetSearchBox() {
    if (this._settingsService.getSearchTerm('inventory_list')) {
      this._searchBox.value = this._settingsService.getSearchTerm('inventory_list');
      this._searchBox.searchClicked();
    }
  }

  getPieces(fabricTypeId: number, branchId: number): Subscription {
    this._loadingService.register('loading');

    return this._inventoryService
      .getPiecesGrouped(fabricTypeId, branchId)
      .subscribe((piecesGrouped: PieceGrouped[]) => {

        console.log('pieces grouped data returned');

        if (Array.isArray(piecesGrouped)) {
          this.data = piecesGrouped;
        } else {
          this.data = new Array<PieceGrouped>();
        }

        this.filteredData = this.data;
        this.filteredTotal = this.data.length;
        this.selectedRows = this.filteredData;

        // Calculate totals
        this.calculateTotals();
        this.filter();

        

        console.log('pieces grouped variables assigned');
        this._loadingService.resolve('loading');

      });
  }

  onSelect(fabricTypeId: number) {

    // Loop through all the observable responses (should only
    // be 1 response: the array of fabric types returned by the service)
    // then loop through the array of fabric types and check if it matches
    // the selected fabric type, if so set the selected fabric type to the element
    this.allFabricTypes$.forEach(
      (result: Fabrictype[]) => result.forEach(
        (element: Fabrictype) => {
          if (fabricTypeId === +element.id) {

            // this element is the selected fabric type
            this._selectedFabricType = element;

            if (element.unit_type == 'AREA') {
              this.availableUnits = ['Meters²', 'SqFt'];
              this._selectedUnit = 'SqFt';
            } else if (element.unit_type == 'LENGTH') {
              this.availableUnits = ['Meters', 'Yards'];
              this._selectedUnit = 'Meters';
            } else {
              this.availableUnits = ['Pieces'];
              this._selectedUnit = 'Pieces';
            }

            this.onUnitChange(this._selectedUnit);
          }
        }));

    
  }

  onUnitChange(unit: string) {
    console.log(unit);
    // Show and hide columns based on selected unit

    switch (unit) {
      case 'Meters': {

        // meters
        this.allColumns = [
          { name: 'collection_name', label: 'Collection' },
          { name: 'design_color', label: 'Design / Color' },
          { name: 'branch', label: 'Branch' },
          { name: 'pieces', label: 'Pieces' },
          { name: 'grade_code', label: 'Grade' },
          { name: 'available', label: 'Available (M)' },
          { name: 'reserved', label: 'Reserved (M)' },
          { name: 'missing', label: 'Back Order (M)' },
          { name: 'ordered', label: 'Ordered (M)' },
          { name: 'actions', label: '' }
        ];

        break;
      }
      case 'Yards': {
        // yards

        this.allColumns = [
            { name: 'collection_name', label: 'Collection' },
            { name: 'design_color', label: 'Design / Color' },
            { name: 'branch', label: 'Branch' },
            { name: 'pieces', label: 'Pieces' },
            { name: 'grade_code', label: 'Grade' },
            { name: 'available_y', label: 'Available (y)' },
            { name: 'reserved_y', label: 'Reserved (y)' },
            { name: 'missing_y', label: 'Back Order (y)' },
            { name: 'ordered_y', label: 'Ordered (y)' },
            { name: 'actions', label: '' }
          ];
        break;
      }
      case 'Meters²': {
        // meters squared

        this.allColumns = [
            { name: 'collection_name', label: 'Collection' },
            { name: 'design_color', label: 'Design / Color' },
            { name: 'branch', label: 'Branch' },
            { name: 'pieces', label: 'Pieces' },
            { name: 'grade_code', label: 'Grade' },
            { name: 'available_Msq', label: 'Available (M²)' },
            { name: 'reserved_Msq', label: 'Reserved (M²)' },
            { name: 'missing_Msq', label: 'Back Order (M²)' },
            { name: 'ordered_Msq', label: 'Ordered (M²)' },
            { name: 'actions', label: '' }
          ];

        break;
      }
      case 'SqFt': {
        // square feet

        this.allColumns = [
            { name: 'collection_name', label: 'Collection' },
            { name: 'design_color', label: 'Design / Color' },
            { name: 'branch', label: 'Branch' },
            { name: 'pieces', label: 'Pieces' },
            { name: 'grade_code', label: 'Grade' },
            { name: 'available_Sft', label: 'Available (SqFt)' },
            { name: 'reserved_Sft', label: 'Reserved (SqFt)' },
            { name: 'missing_Sft', label: 'Back Order (SqFt)' },
            { name: 'ordered_Sft', label: 'Ordered (SqFt)' },
            { name: 'actions', label: '' }
          ];

        break;
      }
      default: {
        // none

        this.allColumns = [
          { name: 'collection_name', label: 'Collection' },
          { name: 'design_color', label: 'Design / Color' },
          { name: 'branch', label: 'Branch' },
          { name: 'pieces', label: 'Pieces' },
          { name: 'grade_code', label: 'Grade' },
          { name: 'reserved_N', label: 'Reserved' },
          { name: 'ordered_N', label: 'Ordered' },
          { name: 'actions', label: '' }
          ];

        break;
      }
    }

  }

  calculateTotals() {
    this.totalPiecesValue = this.data.reduce((acc, el) => acc + +el.pieces, 0);
    this.totalAvailableValue = this.data.reduce((acc, el) => acc + +el.available, 0);
    this.totalReservedValue = this.data.reduce((acc, el) => acc + (+el.reserved || 0), 0);
    this.totalMissingValue = this.data.reduce((acc, el) => acc + (+el.missing || 0), 0);
    this.totalOrderedValue = this.data.reduce((acc, el) => acc + (+el.ordered || 0), 0);

    
  }

  getPageTotals() {
    this.pagePiecesValue = this.filteredData.reduce((acc, el) => acc + +el.pieces, 0);
    this.pageAvailableValue = this.filteredData.reduce((acc, el) => acc + +el.available, 0);
    this.pageReservedValue = this.filteredData.reduce((acc, el) => acc + (+el.reserved || 0), 0);
    this.pageMissingValue = this.filteredData.reduce((acc, el) => acc + (+el.missing || 0), 0);
    this.pageOrderedValue = this.filteredData.reduce((acc, el) => acc + (+el.ordered || 0), 0);

    this.filteredData.push(
      {
        collection_name: 'Totals (page)',
        pieces: this.pagePiecesValue,

        available: this.pageAvailableValue,
        reserved: this.pageReservedValue,
        missing: this.pageMissingValue,
        ordered: this.pageOrderedValue,
        total_row: true
      }
    );

    this.filteredData.push(
      {
        collection_name: 'Totals (all)',
        pieces: this.totalPiecesValue,
        available: this.totalAvailableValue,
        reserved: this.totalReservedValue,
        missing: this.totalMissingValue,
        ordered: this.totalOrderedValue,
        total_row: true
      }
    );
  }

  openPicturesDialog(row) {
    let dialogRef = this._dialog.open(PictureDialog, { width: "400px", height: "400px" });

    if (row['attachments'] == null || row['attachments'] == '' || row['attachments'] == '{}') {
      row['attachments'] = '[]';
    }
    dialogRef.componentInstance.pictures = JSON.parse(row['attachments']);
  }

  openReservedDialog(row) {
    let dialogRef = this._dialog.open(ReservedDialog);

    dialogRef.componentInstance.branch_id = row.branch_id;
    dialogRef.componentInstance.color_id = row.color_id;
  }

  openOrderedDialog(row) {
    let dialogRef = this._dialog.open(OrderedDialog);

    dialogRef.componentInstance.branch_id = row.branch_id;
    dialogRef.componentInstance.color_id = row.color_id;
  }

  openMissingDialog(row) {
    let dialogRef = this._dialog.open(MissingDialog);

    dialogRef.componentInstance.branch_id = row.branch_id;
    dialogRef.componentInstance.color_id = row.color_id;
  }

  openStockHistoryDialog() {
    let reportService = this._reportService;
    let exportService = this._exportService;
    let dialogRef = this._dialog.open(DateSelectDialogComponent);

    dialogRef.componentInstance.instruction = 'Select To Date';

    dialogRef.afterClosed().subscribe((result: { date: string }) => {
      if (result) {
        let date = result.date;
        let branchId = this._selectedBranch;
        reportService.getInventorySnapshot(branchId, date)
          .subscribe(
            result => {
              let snapshots = result.inventory;
              if (Array.isArray(snapshots) && snapshots.length > 0) {
                let snapshot = snapshots[0];
                let inventories = snapshot.inventory;
                exportService.asCsv(inventories, `Stock History Report ${date}`);
              } else {
                this._dialogService.openAlert({ title: 'Error!', message: "No data for the selected options" });
              }
            },
            error => {
              this._dialogService.openAlert({ title: 'Error!', message: "Error creating Stock History Report: " + error });
              console.error(error);
            }
          );

      }
    });
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortOrder = sortEvent.order === TdDataTableSortingOrder.Ascending
      ? TdDataTableSortingOrder.Descending
      : TdDataTableSortingOrder.Ascending;
    this.sortBy = sortEvent.name;
    this.filter();
  }

  search(searchTerm: string): void {
    this._settingsService.setSearchTerm('inventory_list', searchTerm);
    //this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    console.log('filtering');

    let newData: any[] = this.data;
    let excludedColumns: string[] = this.allColumns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });
    newData = this._dataTableService.filterData(newData, this._settingsService.getSearchTerm('inventory_list'), true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;

    this.getPageTotals();
  }

  stockReport() {
    this._reportService.stockReport(this.data);
  }

  detailedStockReport() {
    this._reportService.getDetailedStockReportData(this._selectedBranch + '').subscribe(
      reportData => {
        this._reportService.detailedStockReport(reportData);
      }
    );
  }


  // prompt for collection/design/color
  stockCardReportPrompt() {

    let dRef: MdDialogRef<DateAndProductSelectDialogComponent> = this._dialogService.open(DateAndProductSelectDialogComponent);

    dRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.generateStockCardReport(result.colorId, result.fullName, result.branchId, result.from);
        }
      });
  }

  stockCardReport(pg: PieceGrouped) {
    let dRef: MdDialogRef<DateSelectDialogComponent> = this._dialogService.open(DateSelectDialogComponent);

    dRef.componentInstance.instruction = 'Select From Date';

    dRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.generateStockCardReport(pg.color_id, pg.collection_name + '/' + pg.design_color, pg.branch_id, result.date);
        }
      });

  }


  generateStockCardReport(colorId: number, fullName: string, branchId: number, fromDate: string) {
    // The dialog returns "from" date and "to" is tomorrow (to include all of today)
    let tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    console.log('selected date: ' + fromDate);

    this._reportService.getStockCardReportInfo(fromDate, tomorrow.toISOString().substr(0, 10), branchId + '', colorId + '').subscribe(
      reportData => {
        let array: any[][] = [];
        let entries: any[] = [];

        if (!reportData['data'] || reportData['data'].length <= 0) {
          this._dialogService.openAlert({ title: 'Error!', message: "No data for the selected options" });
          return;
        }

        reportData['data'].forEach(
          r => {
            entries.push({
              date: r.date,
              ref: r.ref,
              receiving_pcs: r.receiving_rolls,
              receiving_mts: r.receiving_meters,
              sales_pcs: r.sales_rolls,
              sales_mts: r.sales_meters,
              sales_cust: r.sales_customer,
              sales_unit_price: r.sales_unit_price,
              sales_total_price: r.sales_total_price,
              adj_pcs: r.adjustment_rolls,
              adj_meters: r.adjustment_meters,
              balance_pcs: 0,
              balance_mts: 0,
              notes: r.notes
            });
          }
        );


        //Calculate backwards to get the original totals
        let _recvd_pieces: number = entries.reduce((a, b) => { return Number.parseFloat(a) + Number.parseFloat(b['receiving_pcs'] || 0) }, 0);
        let _recvd_meters: number = entries.reduce((a, b) => { return Number.parseFloat(a) + Number.parseFloat(b['receiving_mts'] || 0) }, 0);
        let _sold_pieces: number = entries.reduce((a, b) => { return Number.parseFloat(a) + Number.parseFloat(b['sales_pcs'] || 0) }, 0);
        let _sold_meters: number = entries.reduce((a, b) => { return Number.parseFloat(a) + Number.parseFloat(b['sales_mts'] || 0) }, 0);
        let _adjusted_pieces: number = entries.reduce((a, b) => { return Number.parseFloat(a) + Number.parseFloat(b['adj_pcs'] || 0) }, 0);
        let _adjusted_meters: number = entries.reduce((a, b) => { return Number.parseFloat(a) + Number.parseFloat(b['adj_meters'] || 0) }, 0);


        // Trace it back to signs are reversed
        let _balance_pcs: number = reportData['current'][0]['pieces'];
        _balance_pcs = _balance_pcs - _recvd_pieces + _sold_pieces - _adjusted_pieces;
        let _balance_mts: number = reportData['current'][0]['quantity'];
        _balance_mts = _balance_mts - _recvd_meters + _sold_meters - _adjusted_meters;

        array.push([
          'Balance ' + fromDate,
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          _balance_pcs,
          _balance_mts,
          ''
        ]);

        // Calculate the running balance
        entries.sort((a, b) => { return (new Date(a.date) > new Date(b.date)) ? 1 : -1 }).forEach(
          i => {
            _balance_pcs = Number.parseFloat(_balance_pcs + '') + Number.parseFloat(i.receiving_pcs) - Number.parseFloat(i.sales_pcs) + Number.parseFloat(i.adj_pcs);
            _balance_mts = Number.parseFloat(_balance_mts + '') + Number.parseFloat(i.receiving_mts) - Number.parseFloat(i.sales_mts) + Number.parseFloat(i.adj_meters);

            array.push([
              i.date.substr(0, 10),
              i.ref,
              i.receiving_pcs,
              i.receiving_mts,
              i.sales_pcs,
              i.sales_mts,
              i.sales_cust,
              parseFloat(i.sales_unit_price.toString()).toFixed(2),
              parseFloat(i.sales_total_price.toString()).toFixed(2),
              i.adj_pcs,
              i.adj_meters,
              _balance_pcs,
              _balance_mts,
              i.notes
            ]);
          }
        );

        array.push([
          'TOTAL',
          '',
          entries.reduce((a, b) => { return Number.parseFloat(a) + Number.parseFloat(b['receiving_pcs'] || 0) }, 0),
          entries.reduce((a, b) => { return Number.parseFloat(a) + Number.parseFloat(b['receiving_mts'] || 0) }, 0),
          entries.reduce((a, b) => { return Number.parseFloat(a) + Number.parseFloat(b['sales_pcs'] || 0) }, 0),
          entries.reduce((a, b) => { return Number.parseFloat(a) + Number.parseFloat(b['sales_mts'] || 0) }, 0),
          '',
          '',
          '',
          entries.reduce((a, b) => { return Number.parseFloat(a) + Number.parseFloat(b['adj_pcs'] || 0) }, 0),
          entries.reduce((a, b) => { return Number.parseFloat(a) + Number.parseFloat(b['adj_meters'] || 0) }, 0),
          '',
          '',
          ''
        ]);



        array.push([
          'BALANCE ' + tomorrow.toISOString().substr(0, 10),
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          reportData['current'][0]['pieces'],
          reportData['current'][0]['quantity'],
          ''
        ]);

        console.log(array);

        this._reportService.stockCardReport(
          array,
          fullName,
          branchId.toString(),
          fromDate,
          tomorrow.toISOString().substr(0, 10)
        );
      }
    )
  }
}



@Component({
  selector: 'picture-dialog',
  template: `
    <div flex layout="column" layout-margin layout-wrap>
      <img [src]="pictures[current_image]" style="max-width:100%; max-height:100%;">
    </div>
  `,
})
export class PictureDialog implements OnInit {
  pictures: any[] = [];

  current_image: number = 0;

  constructor(public dialogRef: MdDialogRef<PictureDialog>,
    private tdDialog: TdDialogService) { }

  ngOnInit() {
    if (this.pictures.length == 0) {
      this.pictures.push('http://get.cppqnet.com.pe/images/LogoCiaPrincipal/noimage.jpg');
    }
  }

  move(offset: number) {
    if ((this.current_image + offset) >= 0 && (this.current_image + offset) < this.pictures.length) {
      this.current_image += offset;
    }
  }
}

@Component({
  selector: 'reserved-dialog',
  template: `
  <div flex layout="column" layout-margin layout-wrap>
    <md-list *ngIf="lines.length > 0">
      <md-list-item *ngFor="let l of lines" [routerLink]="['/sales', 'edit', l.id]" style="cursor:pointer" (click)="dialogRef.close()">
        <h4 md-line>{{l.order_number}}</h4>
        <p md-line *ngIf="l.id != 0">{{l.quantity}} meters - Customer: {{l.customer_name}}</p>
      </md-list-item>
    </md-list>
    <span *ngIf="lines.length == 0">No reserved meterage</span>
  </div>
  `,
})
export class ReservedDialog implements OnInit {
  lines: any[] = [{ id: 0, order_number: 'Loading...', quantity: 0, customer_name: '' }];

  color_id: number;
  branch_id: number;

  constructor(public dialogRef: MdDialogRef<ReservedDialog>,
    private tdDialog: TdDialogService,
    private _inventoryService: InventoryService
  ) { }

  ngOnInit() {
    this._inventoryService.getPiecesReservedDetail(this.color_id, this.branch_id).subscribe(
      response => {
        console.log('reserved dialog on init');
        this.lines = [];
        response.forEach((l) => this.lines.push({ id: l.id, order_number: l.order_number, quantity: l.quantity, customer_name: l.customer_name }));
      }
    );
  }
}

@Component({
  selector: 'ordered-dialog',
  template: `
    <div flex layout="column" layout-margin layout-wrap>
      <md-list *ngIf="lines.length > 0">
        <md-list-item *ngFor="let l of lines" (click)="dialogRef.close()">
          <h4 md-line>{{l.po_number}}</h4>
          <p md-line *ngIf="l.id != 0">{{l.qty}} meters - ETA: {{l.estimated_arrival_date}}</p>
          
        </md-list-item>
      </md-list>
      <span *ngIf="lines.length == 0">No ordered meterage</span>
    </div>
  `,
})
export class OrderedDialog implements OnInit {
  lines: any[] = [{ id: 0, po_number: 'Loading...', qty: 0, estimated_arrival_date: '' }];

  color_id: number;
  branch_id: number;

  constructor(public dialogRef: MdDialogRef<ReservedDialog>,
    private tdDialog: TdDialogService,
    private _inventoryService: InventoryService,
    private _authService: AuthenticationService
  ) { }

  ngOnInit() {
    this._inventoryService.getPiecesOrderedDetail(this.color_id, this.branch_id).subscribe(
      response => {
        console.log('ordered dialog on init');
        this.lines = [];
        if (Array.isArray(response)) {
          response.forEach((l) => this.lines.push({ id: l.id, po_number: l.po_number, qty: l.qty, estimated_arrival_date: l.estimated_arrival_date }));
        }
      }
    );
  }
}

@Component({
  selector: 'missing-dialog',
  template: `
    <div flex layout="column" layout-margin layout-wrap>
      <md-list *ngIf="lines.length > 0">
        <md-list-item *ngFor="let l of lines" [routerLink]="['/backorder', 'edit', l.id]" style="cursor:pointer" (click)="dialogRef.close()">
          <h4 md-line>{{l.bo_number}}</h4>
          <p md-line *ngIf="l.id != 0">{{l.qty}} meters - Customer: {{l.customer_name}}</p>
        </md-list-item>
      </md-list>
      <span *ngIf="lines.length == 0">No missing meterage</span>
    </div>
  `,
})
export class MissingDialog implements OnInit {
  lines: any[] = [{ id: 0, bo_number: 'Loading...', qty: 0 }];

  color_id: number;
  branch_id: number;

  constructor(public dialogRef: MdDialogRef<ReservedDialog>,
    private tdDialog: TdDialogService,
    private _inventoryService: InventoryService
  ) { }

  ngOnInit() {
    this._inventoryService.getPiecesMissingDetail(this.color_id, this.branch_id).subscribe(
      response => {
        console.log('missing dialog on init');
        this.lines = [];
        response.forEach((l) => this.lines.push({ id: l.id, bo_number: l.bo_number, qty: l.qty, customer_name: l.customer_name }));
      }
    );
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/inventory/inventory-list/inventory-list.component.ts